import { useState, useContext } from 'react';
import GalleryShareContext from './GalleryShareContext';
import { Input } from '@/src/shadComponents/ui/input';
import axios from 'axios';

interface ShareModalProps {
    setShowShareModal: (show: boolean) => void;
    shareIdentifiers: string[];
    ipAddress: string;
    port: number;
    photos: MediaInstance[];
    endpoint: string;
}

export default function DeepLocalSharingStationModal({
    ipAddress,
    port,
    setShowShareModal,
    shareIdentifiers,
    photos,
    endpoint,
}: ShareModalProps) {
    const [, setIsSharingComplete] = useState(false);
    const [code, setCode] = useState('');
    const [isSending, setIsSending] = useState(false);
    const [error, setError] = useState<string | null>(null);
    // @ts-ignore
    const { setHideShareModal } = useContext(GalleryShareContext);

    const sendToDeepLocal = async () => {
        setIsSending(true);
        const imageUrl = photos.find(
            (photo) => photo.shareIdentifier === shareIdentifiers[0],
        )?.originalUri;

        if (!imageUrl) {
            setError('Image not found');
            return;
        }

        if (!code) {
            setError('Please enter a code');
            return;
        }

        const api = axios.create({
            baseURL: `https://${ipAddress}:${port}`,
        });

        try {
            const response = await api.post(endpoint, {
                guestId: code,
                url: imageUrl,
            });
            if (response.status === 200) {
                setIsSharingComplete(true);
                setHideShareModal && setHideShareModal();
            }
        } catch (error) {
            setError('Error sending to DeepLocal');
            console.error(error);
        }

        setIsSending(false);
    };

    return (
        <div className="Fullscreen-modal">
            <div
                className="close-modal"
                onClick={() => setShowShareModal(false)}
            >
                <i className="bi bi-x"></i>
            </div>
            <div className="flex justify-center content-center w-full h-screen">
                <div className="m-auto flex-col justify-center content-center">
                    <p className="center uppercase">Enter Code</p>
                    <br />

                    <Input
                        type="text"
                        placeholder="Code"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        className="w-[200px] text-center border-2 border-gray-300 rounded-xl p-5 text-xl"
                        autoFocus={true}
                    />
                    <br />
                    {error && (
                        <div className="flex justify-center">
                            <p className="text-red-500">{error}</p>
                        </div>
                    )}
                    <br />
                    <div className="flex justify-center">
                        {isSending ? (
                            <div role="status" className="ml-2">
                                <svg
                                    aria-hidden="true"
                                    className="inline w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                                    viewBox="0 0 100 101"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor"
                                    />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill"
                                    />
                                </svg>
                                <span className="sr-only">Loading...</span>
                            </div>
                        ) : (
                            <div
                                onClick={sendToDeepLocal}
                                className="cta-button no-border"
                            >
                                Share
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
